import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = (() => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return window.location.origin + '/api';
  }
  return (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001') + '/api';
})();

export default function AppleAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      const messages = {
        apple_denied: 'Apple sign-in was cancelled.',
        token_exchange_failed: 'Unable to complete Apple sign-in. Please try again.',
        no_email: 'No email was returned from Apple.',
        apple_error: 'Apple sign-in encountered an error. Please try again.',
        key_not_found: 'Authentication key error. Please try again.',
        token_verify_failed: 'Token verification failed. Please try again.',
      };
      navigate('/login', { replace: true, state: { message: messages[error] || 'Apple sign-in failed.' } });
      return;
    }

    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        localStorage.setItem('token', token);
        localStorage.setItem('keepLoggedIn', 'true');
        localStorage.setItem('loginExpiry', (Date.now() + 30 * 24 * 60 * 60 * 1000).toString());
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        localStorage.setItem('user', JSON.stringify(res.data));

        window.location.href = '/dashboard';
      } catch (err) {
        console.error('Apple auth callback error:', err);
        localStorage.removeItem('token');
        navigate('/login', { replace: true, state: { message: 'Failed to complete sign-in. Please try again.' } });
      }
    })();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-300 text-sm">Signing in with Apple...</p>
      </div>
    </div>
  );
}
